module.exports = __webpack_public_path__ + "img/vision.c89658b8.jpg";